import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    height={`${size}`}
    width={`${size}`}
    fill="none"
    {...props}
  >
    <path d="M17.241 12H7.127" stroke={color} strokeWidth={2} />
  </svg>
);
